// extracted by mini-css-extract-plugin
module.exports = {"star":"starrating_star__F36CK","count":"starrating_count__RxRNx","rating":"starrating_rating__nmNlc"};